import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.find-index";
import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import border from "../com/border";
import aMap from "../com/map";
import analysis from "../com/analysis";
import site from "../static/site.json";
import tideAnalysis from "../com/tideAnalysis";
import fileTable from "../com/fileTable";
import moment from 'moment';
import { queryWastehydrologyCurveAnalysis } from '@/api/api';
import { getAction } from '@/api/manage';
export default {
  name: 'atmosphere',
  components: {
    border: border,
    aMap: aMap,
    analysis: analysis,
    tideAnalysis: tideAnalysis,
    fileTable: fileTable
  },
  data: function data() {
    return {
      radio: '',
      radioOptions: [],
      radio1: '',
      radioOptions1: [],
      moment: moment,
      showAnalysis: false,
      showTideAnalysis: false,
      showTideAnalysis1: false,
      site: site,
      selectType: 2,
      selectTab: [{
        name: '大型(0)',
        type: 0
      }, {
        name: '中型(0)',
        type: 1
      }, {
        name: '小I型(2)',
        type: 2
      }, {
        name: '小II型(0)',
        type: 3
      }],
      dateList: [],
      realRainyArr: [],
      tabList: [],
      selectedTabId: '',
      showFileTable: false
    };
  },
  mounted: function mounted() {},
  watch: {
    radio: function radio() {
      this.showTide();
    },
    radio1: function radio1() {
      this.showTide('1');
    }
  },
  methods: {
    getSiteTab: function getSiteTab(siteTab) {
      var _this = this;

      siteTab.forEach(function (item) {
        item.id = item.type;

        if (item.type < 4) {
          _this.tabList.push(item);
        }
      });
      this.onToSelectedTab({
        id: ''
      });
    },
    onToSelectedTab: function onToSelectedTab(item) {
      if (item.id === this.selectedTabId) {
        item = {
          type: '',
          id: ''
        };
      }

      this.selectedTabId = item.id;
      this.showDateList(item);
    },
    getSiteData: function getSiteData(siteArr) {
      var _this2 = this;

      console.log('siteArr', siteArr);
      siteArr = siteArr.filter(function (item) {
        return item.st == 61;
      });
      this.site = siteArr;
      this.dateList = [];
      var siteArrs = [];
      this.siteData = this.site.filter(function (item) {
        return item.type < 4;
      });
      this.siteData.forEach(function (item) {
        siteArrs.push(item.id);
      });
      var param = {
        stime: moment().format('YYYY-MM-DD'),
        etime: moment().format('YYYY-MM-DD'),
        quantum: siteArrs.join(','),
        type: 7,
        column: 'data_time',
        order: 'asc',
        dataType: 11
      };
      this.resData = [];
      this.radioOptions = [];
      this.factorMap = {};
      queryWastehydrologyCurveAnalysis(param).then(function (res) {
        if (res.success) {
          _this2.resData = res.result.records;
        }

        _this2.showRealRainy(); //实时降雨


        _this2.showTide();
      });
      this.getSiteFlow();
    },
    showRealRainy: function showRealRainy() {
      var _this3 = this;

      var time = [];
      var labelData = [];
      var popArr = [];
      var arr = [];
      this.siteData.forEach(function (item) {
        labelData.push(item.name);
        popArr.push({
          data: [],
          title: item.name
        });
      });
      this.siteData.forEach(function (ele, index) {
        _this3.resData.forEach(function (item) {
          arr.push({
            name: item.dataTime,
            value: item.data[ele.id] && item.data[ele.id].hasOwnProperty('sl021') && item.data[ele.id]['sl021'] !== null && item.data[ele.id]['sl021'] !== '' ? item.data[ele.id]['sl021'] : ''
          });
        });

        popArr[index].data = arr;
        arr = [];
      });
      this.resData.forEach(function (item) {
        time.push(item.dataTime);
      });
      this.showAnalysis = false;
      this.$nextTick(function () {
        _this3.showAnalysis = true;

        _this3.$nextTick(function () {
          _this3.$refs.pollution.initBarChart(popArr, time, labelData, undefined, 3, '降雨量(mm)');
        });
      });
    },
    getSiteFlow: function getSiteFlow() {
      var _this4 = this;

      var arr = [];
      var site = [403, 404];
      var site1 = [];
      this.siteData.forEach(function (item) {
        if (site.findIndex(function (data) {
          return data === item.id;
        }) == -1) {
          site1.push(item.id);
        }
      });
      arr.push(this.getSiteFlowApi(site));
      arr.push(this.getSiteFlowApi(site1));
      Promise.all(arr).then(function (data) {
        _this4.handleRadioData(data[0], site, '');

        _this4.handleRadioData(data[1], site1, '1');
      });
    },
    handleRadioData: function handleRadioData(res, site, str) {
      var _this5 = this;

      this['factorMap' + str] = {};
      this['resDataWater' + str] = res.result.records;
      this['radioOptions' + str] = [];
      res.result.query.factors.forEach(function (item) {
        var factorObj = item;
        item.factorObj = {};

        _this5.siteData.filter(function (item) {
          return site.indexOf(item.id) > -1;
        }).forEach(function (item1) {
          var obj = JSON.parse(JSON.stringify(item1));
          obj.factor = JSON.parse(JSON.stringify(item));
          obj.arr = [];
          res.result.records.forEach(function (item2) {
            obj.arr.push(item2.data && item2.data[item1.id] && item2.data[item1.id].hasOwnProperty(item.code) && item2.data[item1.id][item.code] !== null && item2.data[item1.id][item.code] !== '' ? item2.data[item1.id][item.code] : '');
          });
          item.factorObj[item1.id] = obj;
        });

        _this5['factorMap' + str][item.code] = factorObj;

        if (item.code != 'sl021') {
          _this5['radioOptions' + str].push(item);
        }
      });
      this['radio' + str] = this['radioOptions' + str].length > 0 ? this['radioOptions' + str][0].code : '';
    },
    getSiteFlowApi: function getSiteFlowApi(siteArrs) {
      var param = {
        stime: moment().format('YYYY-MM-DD'),
        etime: moment().format('YYYY-MM-DD'),
        quantum: siteArrs.join(','),
        type: 7,
        column: 'data_time',
        order: 'asc',
        dataType: 11
      };
      return new Promise(function (resolve, reject) {
        queryWastehydrologyCurveAnalysis(param).then(function (res) {
          resolve(res);
        }).catch(function (err) {
          reject(err);
        });
      });
    },
    showTide: function showTide() {
      var _this6 = this;

      var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var xAxisData = [];
      var yAxisData = [];
      this['resDataWater' + str].forEach(function (item) {
        xAxisData.push(item.dataTime);
      });
      var factorMap = this['factorMap' + str];
      var radio = this['radio' + str];

      for (var i in factorMap[radio].factorObj) {
        yAxisData.push({
          title: factorMap[radio].factorObj[i].name,
          data: factorMap[radio].factorObj[i].arr
        });
      }

      this['showTideAnalysis' + str] = false;
      this.$nextTick(function () {
        _this6['showTideAnalysis' + str] = true;

        _this6.$nextTick(function () {
          _this6.$refs['tideAnalysisRef' + str].initBarChart(xAxisData, yAxisData, "".concat(factorMap[radio].title, "(").concat(factorMap[radio].unitName, ")"));
        });
      });
    },
    showDateList: function showDateList(data) {
      var _this7 = this;

      if (this.selectedTabId == 1) {
        this.column = [{
          label: '站点',
          code: 'siteName'
        }, {
          label: '时间',
          code: 'dataTime'
        }, {
          label: '水位(m)',
          code: 'sl011'
        }, {
          label: '降雨量(mm)',
          code: 'sl021'
        }];
      } else {
        this.column = [{
          label: '站点',
          code: 'siteName'
        }, {
          label: '时间',
          code: 'dataTime'
        }, {
          label: '水位(m)',
          code: 'sl011'
        }, {
          label: '流速(m/s)',
          code: 'sl012'
        }, {
          label: '降雨量(mm)',
          code: 'sl021'
        }];
      }

      this.dateList = [];
      getAction("/online/st61/siteWaterAndRain", {
        category: data.type
      }).then(function (res) {
        if (res.success) {
          _this7.showFileTable = false;

          _this7.$nextTick(function () {
            _this7.showFileTable = true;

            _this7.$nextTick(function () {
              _this7.dateList = res.result;
            });
          });
        }
      });
    }
  }
};